{
  "primary": "#333333",
  "secondary": "#000000",
  "background": "#FFFFFF",
  "contextual": "#D9D9D9",
  "progressBar": {
    "foregroundColor": "#000000",
    "backgroundColor": "#CCCCCC"
  }
}